import { useEffect, useState } from 'react';

// graphql
import { CashTransferStatus, PageInfo, useApt_PlayerBalanceWithdrawalsQuery } from '@/generated/graphql';

// interfaces
import {
  IPlayerBalanceWithdrawal,
  IPlayerBalanceWithdrawalQueryVariable,
  mapGQLPlayerBalanceWithdrawal,
  IPlayerWithdrawalTransactionTable_AD,
} from '@/shared/interfaces';

// helpers
import { formatNumber } from '@/shared/constants';

// components
import { TablePlayerBalanceWithdrawals } from './table';

export const PlayerWithdrawals = () => {
  const [withdrawals, setWithdrawals] = useState<IPlayerWithdrawalTransactionTable_AD[]>([]);

  const [queryVariable, setQueryVariable] = useState<IPlayerBalanceWithdrawalQueryVariable>({
    first: 25,
    filterBy: {
      status: [CashTransferStatus.VirifiedByCashier],
    },
  });
  const [withdrawalPageInfo, setWithdrawalPageInfo] = useState<PageInfo>();
  const [withdrawalTotalCount, setWithdrawalTotalCount] = useState<number>(0);

  const {
    data: withdrawalData,
    loading: withdrawalLoading,
    error: withdrawalError,
    refetch: withdrawalRefetch,
  } = useApt_PlayerBalanceWithdrawalsQuery({
    fetchPolicy: 'network-only',
    variables: queryVariable,
    pollInterval: 6500,
  });

  useEffect(() => {
    if (withdrawalData && !withdrawalLoading && !withdrawalError) {
      const mapPlayerBalanceWithdrawals: IPlayerBalanceWithdrawal[] = withdrawalData.playerBalanceWithdrawals.nodes.map(
        (playerBalanceWithdrawal) => mapGQLPlayerBalanceWithdrawal(playerBalanceWithdrawal),
      );

      const tableData = mapPlayerBalanceWithdrawals.map((x) => ({
        id: x.id,
        amountDisplay: formatNumber(x.amount),
        referenceId: x.referenceId,
        transactionType: x.transactionType,
        createdAt: x.createdAt,
        status: x.status,
        receiverAccountNumber: x.receiverAccountNumber,
        senderAccountNumber: x.senderAccountNumber,

        playerName: `${x.player.firstName} ${x.player.lastName}`,
        cashierName: `${x.cashier.firstName} ${x.cashier.lastName}`,
        auditorId: x.auditor.id,
      }));

      if (withdrawals.length === 0 && tableData.length > 0) {
        setWithdrawals(tableData);
      } else {
        let allStatusMatch = true;

        withdrawals.forEach((withdrawal) => {
          const found = tableData.find((x) => x.id === withdrawal.id);

          if (found && (found.status !== withdrawal.status || (found.auditorId.length > 2 && withdrawal.auditorId.length === 0))) {
            allStatusMatch = false;
          }
        });

        if (tableData.length !== withdrawals.length || !allStatusMatch) {
          setWithdrawals(() => tableData);
        }
      }
    }
  }, [withdrawalLoading, withdrawalError, withdrawalData]);

  return (
    <>
      <TablePlayerBalanceWithdrawals
        rows={withdrawals}
        setPlayerBalanceWithdrawalQueryVariable={setQueryVariable}
        playerBalanceWithdrawalQueryVariable={queryVariable}
        totalCount={withdrawalTotalCount}
        pageInfo={withdrawalPageInfo}
        getPlayerBalanceWithdrawalLoading={withdrawalLoading}
        refetch={withdrawalRefetch}
      />
    </>
  );
};
